import React from 'react'

import type { LinkDetail } from '@vividseats/vivid-ui-kit'
import { LinkBank } from '@vividseats/vivid-ui-kit'

import type { LinkDetail as WidgetLinkDetail } from '@/components/shared/link-widget'
import LinkWidget from '@/components/shared/link-widget'

import { getWidgetLinks } from './utils'

interface PerformerLinksProps {
    title: string
    variant?: 'LinkBank' | 'LinkWidget'
    links: LinkDetail[]
}

const PerformerLinks: React.FC<PerformerLinksProps> = ({ title, variant = 'LinkBank', links = [] }) => {
    const variantComponent = () => {
        switch (variant) {
            case 'LinkBank': {
                return <LinkBank title={title} links={links} numberOfColumns={2} />
            }
            case 'LinkWidget': {
                const widgetLinks: WidgetLinkDetail[] = getWidgetLinks(links)
                return <LinkWidget title={title} links={widgetLinks} />
            }
        }
    }

    return variantComponent()
}

export default PerformerLinks
